const state = {
  musicVolume: 0.15,
  soundVolume: 0.7,
  ambientVolume: 0.5, // New dedicated volume for ambient sounds
  isMusicMuted: false,
  isSoundMuted: false,
  isAmbientMuted: false, // New mute setting for ambient sounds
  isUiClickMuted: false, // Add new state for UI click mute
  currentMusic: null,
  currentSound: null,
  currentMusicInfo: null,
  isPlaying: false,
  autoplayFailed: false,
  isInitialized: false,
  autoMusicSwitchAttempts: 0, // Counter for automated music switch attempts
  globalRetryAttempts: 0, // New global counter for all music retry attempts
  maxRetryAttempts: 3, // Maximum number of retry attempts
  waitingForInteraction: false, // Flag to track if we're waiting for user interaction
  interactionObserverAttached: false, // Track if the observer is already attached
  allMusicInstances: [], // Add a new array to track all music instances

  // Separate music playlists from sound effects
  musicPlaylists: {
    ambient: [
      {
        "path": "/musics/back-to-the-past-263522.mp3",
        "title": "Back To The Past",
        "artist": "Quincas Moreira"
      },
      {
        "path": "/musics/chill-retrowave-cassette-161629.mp3",
        "title": "Chill Retrowave Cassette",
        "artist": "SoulProdMusic"
      },
      {
        "path": "/musics/chill-synthwave-211190.mp3",
        "title": "Chill Synthwave",
        "artist": "AlexiAction"
      },
      {
        "path": "/musics/cool-retro-darkwavesynthwave-type-beat-shadows-211527.mp3",
        "title": "Cool Retro Darkwavesynthwave Type Beat Shadows",
        "artist": "INOSSI"
      },
      {
        "path": "/musics/disco-271528.mp3",
        "title": "Disco",
        "artist": "DreamHeaven"
      },
      {
        "path": "/musics/fury-253300.mp3",
        "title": "Fury",
        "artist": "Roman Senyk"
      },
      {
        "path": "/musics/heavy-cyberpunk-metal-188529.mp3",
        "title": "Heavy Cyberpunk Metal",
        "artist": "AudioCoffee"
      },
      {
        "path": "/musics/intersection-226780.mp3",
        "title": "Intersection",
        "artist": "Evgeny Bardyuzha"
      },
      {
        "path": "/musics/JDB - Airwave.mp3",
        "title": "Jdb   Airwave",
        "artist": "JDB Artist"
      },
      {
        "path": "/musics/JDB - Ashen Queen.mp3",
        "title": "Ashen Queen",
        "artist": "JDB Artist"
      },
      {
        "path": "/musics/JDB - Dark Power.mp3",
        "title": "Dark Power",
        "artist": "JDB Artist"
      },
      {
        "path": "/musics/JDB - Echelon.mp3",
        "title": "Echelon",
        "artist": "JDB Artist"
      },
      {
        "path": "/musics/JDB - Fighting Will.mp3",
        "title": "Fighting Will",
        "artist": "JDB Artist"
      },
      {
        "path": "/musics/JDB - Graveyard.mp3",
        "title": "Graveyard",
        "artist": "JDB Artist"
      },
      {
        "path": "/musics/JDB - Her Name is Madness.mp3",
        "title": "Her Name Is Madness",
        "artist": "JDB Artist"
      },
      {
        "path": "/musics/JDB - Hunters.mp3",
        "title": "Hunters",
        "artist": "JDB Artist"
      },
      {
        "path": "/musics/JDB - Ivory And Scarlett.mp3",
        "title": "Ivory And Scarlett",
        "artist": "JDB Artist"
      },
      {
        "path": "/musics/JDB - Lost.mp3",
        "title": "Lost",
        "artist": "JDB Artist"
      },
      {
        "path": "/musics/JDB - Madden Scientist Gone to Hell.mp3",
        "title": "Madden Scientist Gone To Hell",
        "artist": "JDB Artist"
      },
      {
        "path": "/musics/JDB - Old School Run.mp3",
        "title": "Old School Run",
        "artist": "JDB Artist"
      },
      {
        "path": "/musics/JDB - Old School Trap.mp3",
        "title": "Old School Trap",
        "artist": "JDB Artist"
      },
      {
        "path": "/musics/JDB - Tense Atmosphere.mp3",
        "title": "Tense Atmosphere",
        "artist": "JDB Artist"
      },
      {
        "path": "/musics/JDB - The Fallen King.mp3",
        "title": "The Fallen King",
        "artist": "JDB Artist"
      },
      {
        "path": "/musics/JDB - Twisted Dreams Gone Wild.mp3",
        "title": "Twisted Dreams Gone Wild",
        "artist": "JDB Artist"
      },
      {
        "path": "/musics/JDB - Uneven Fight.mp3",
        "title": "Uneven Fight",
        "artist": "JDB Artist"
      },
      {
        "path": "/musics/lumiessence-retrowave-chillout-173650.mp3",
        "title": "Lumiessence Retrowave Chillout",
        "artist": "Cyber Dreams"
      },
      {
        "path": "/musics/mc-quattro-back-to-the-future-retrowave-punk-20775.mp3",
        "title": "Mc Quattro Back To The Future Retrowave Punk",
        "artist": "MC Quattro"
      },
      {
        "path": "/musics/mezhdunami-meteor-shower-141278.mp3",
        "title": "Mezhdunami Meteor Shower",
        "artist": "Mezhdunami"
      },
      {
        "path": "/musics/nu-metal-with-solo-109316.mp3",
        "title": "Nu Metal With Solo",
        "artist": "AlexGrohl"
      },
      {
        "path": "/musics/searching-for-the-truth-226789.mp3",
        "title": "Searching For The Truth",
        "artist": "SoulProdMusic"
      },
      {
        "path": "/musics/smell-of-love-304994.mp3",
        "title": "Smell Of Love",
        "artist": "DayFox"
      },
      {
        "path": "/musics/supermoon-225336.mp3",
        "title": "Supermoon",
        "artist": "UNIVERSFIELD"
      },
      {
        "path": "/musics/uncharted-territory-8682.mp3",
        "title": "Uncharted Territory",
        "artist": "Aaron Kenny"
      },
      {
        "path": "/musics/when-you-leave-318882.mp3",
        "title": "When You Leave",
        "artist": "DreamHeaven"
      }
    ]
  },

  // Separate sound effects configuration
  soundEffects: {
    chest: {
      open: '/sounds/chest_open.mp3',
      close: '/sounds/chest_close.mp3'
    },
    city: {
      ambient: '/sounds/City/ambient.mp3',
    },
    bar: {
      ambient: '/sounds/Bar/ambient2.mp3',
      search: '/sounds/Bar/search.mp3',
      candidateFound: '/sounds/Bar/candidateFound.mp3',
    },
    battle: {
      handAttack: '/sounds/Battle/swordDamage2.wav',
      handAttack2: '/sounds/Battle/swordDamage.wav',
      gunAttack: '/sounds/Battle/gunShot.mp3',
      talentUse: '/sounds/Battle/fansGritando.mp3',
      cheerFans: '/sounds/Battle/torcida4.mp3',
      cheerFansGrandStadium: '/sounds/Battle/torcidaEmGrandeArena.mp3',
      victoryCry: '/sounds/Battle/youWinCry.mp3',
      victoryCry2: '/sounds/Battle/youWinCry2.mp3',
      victoryCry3: '/sounds/Battle/youWinCry3.mp3',
      victoryRobotic: '/sounds/Battle/youWinRobotic.mp3',
      victoryRobotic2: '/sounds/Battle/youWinRobotic2.mp3',
      defeat: '/sounds/Battle/defeat.mp3',
      deadFighter: '/sounds/Battle/dieFighter.mp3',
      finalization: '/sounds/Battle/finalization.wav',
      fuck: '/sounds/Battle/FUCK.mp3',
      start: '/sounds/UI/InitBattle.wav',
    },
    premiumItens: {
      drinkTonic: '/sounds/premiumItems/drink_tonic.mp3',
      chestOpen: '/sounds/premiumItems/chest_open.mp3',
      legendaryItem: '/sounds/premiumItems/legendary.mp3',
      getReward: '/sounds/premiumItems/chime.mp3'
    },
    minigames: {
      initGame: '/sounds/Minigames/enterMinigame.wav',
      victory: {
        easy: '/sounds/Minigames/RisadasDeVitoria/risadaFacil.mp3',
        medium: '/sounds/Minigames/RisadasDeVitoria/risadaMedia.mp3',
        hard: '/sounds/Minigames/RisadasDeVitoria/risadaDificil.mp3'
      },
      defeat: {
        oneDefeat: '/sounds/Minigames/homemGritando.mp3',
        twoDefeat: '/sounds/Minigames/ChoroDeDerrota/choroDeDerrota.mp3',
        fiveDefeat: '/sounds/Minigames/ChoroDeDerrota/choroDeHumilhacao.mp3'
      },
      fuga: {
        carrosBatendo:  '/sounds/Minigames/Fuga/carrosBatendo.mp3',
        derrapagem: '/sounds/Minigames/Fuga/derrapagem.mp3',
        sirenePolicia: '/sounds/Minigames/Fuga/sirenePolicia.mp3',
        carroAcelerando: '/sounds/Minigames/Fuga/carroAcelerando.mp3',
        powerUp: '/sounds/Minigames/Fuga/powerUp.mp3',
      },
      forjaDeArmas: {
        mergeNoCombo: '/sounds/Minigames/ForjaDeArmas/merge2.wav',
        merge3Combo: '/sounds/Minigames/ForjaDeArmas/merge.wav',
        merge5Combo: '/sounds/Minigames/ForjaDeArmas/Wow.mp3',
        merge10Combo: '/sounds/Minigames/ForjaDeArmas/Amazing.mp3',
        hammer: '/sounds/Minigames/ForjaDeArmas/martelo.wav',
        furnace: '/sounds/Minigames/ForjaDeArmas/merge3.wav',
        lightning: '/sounds/Minigames/ForjaDeArmas/lightning.wav',
      },
      construcaoDeMuro: {
        colocandoBloco: '/sounds/Minigames/ConstrucaoDeMuro/colocandoBloco.mp3',
        completeLine: '/sounds/Minigames/ConstrucaoDeMuro/ohYeah.mp3',
        rotateBlock: '/sounds/Minigames/ConstrucaoDeMuro/rotateBlock.mp3',
      }
    },
    ui: {
      click: '/sounds/UI/Click.mp3',
      productionComplete: '/sounds/UI/ProductionComplete.wav',
      initProduction: '/sounds/UI/ProductionComplete.wav',
      initBattle: '/sounds/UI/InitBattle.wav',
      acceptBattle: '/sounds/UI/AcceptBattle.wav',
      levelUp: '/sounds/UI/LevelUp.wav',
      success: '/sounds/UI/LevelUp.wav',
      error: '/sounds/UI/Error.mp3',
      notification: '/sounds/UI/Notification.mp3',
      thankYou: '/sounds/UI/thankYou.mp3'
    },
    rewards: {
      coins: '/sounds/reward_coins.mp3',
      item: '/sounds/reward_item.mp3',
      levelUp: '/sounds/level_up.mp3'
    },
    roulette: {
      spin: '/sounds/roulette/roulette_spin.mp3',
      win: '/sounds/roulette/roulette_win.mp3',
    },
    shop: {
      buy: '/sounds/UI/Compra.wav',
      sell: '/sounds/UI/Venda.wav',
      changeBuy: '/sounds/UI/cha-ching.mp3'
    }
  }
}

const getters = {
  effectiveMusic: state => {
    return state.isMusicMuted ? 0 : state.musicVolume
  },
  effectiveSound: state => {
    return state.isSoundMuted ? 0 : state.soundVolume
  },
  effectiveAmbient: state => {
    return state.isAmbientMuted ? 0 : state.ambientVolume
  },
  effectiveUiClick: state => {
    return state.isUiClickMuted ? false : !state.isSoundMuted
  }
}

const mutations = {
  SET_MUSIC_VOLUME(state, volume) {
    state.musicVolume = volume
  },
  SET_SOUND_VOLUME(state, volume) {
    state.soundVolume = volume
  },
  SET_AMBIENT_VOLUME(state, volume) {
    state.ambientVolume = volume;
    // Não atualizamos diretamente os sons aqui, isso será feito pela action
  },
  TOGGLE_MUSIC_MUTE(state) {
    state.isMusicMuted = !state.isMusicMuted
  },
  TOGGLE_SOUND_MUTE(state) {
    state.isSoundMuted = !state.isSoundMuted
  },
  TOGGLE_AMBIENT_MUTE(state) {
    state.isAmbientMuted = !state.isAmbientMuted;
    // Não atualizamos diretamente os sons aqui, isso será feito pela action
  },
  TOGGLE_UI_CLICK_MUTE(state) {
    state.isUiClickMuted = !state.isUiClickMuted
  },
  SET_CURRENT_MUSIC(state, music) {
    state.currentMusic = music
    
    // Add the new music to our tracking array if it's not null
    if (music && !state.allMusicInstances.includes(music)) {
      state.allMusicInstances.push(music);
    }
  },
  CLEAR_ALL_MUSIC_INSTANCES(state) {
    state.allMusicInstances = [];
  },
  REMOVE_MUSIC_INSTANCE(state, musicToRemove) {
    state.allMusicInstances = state.allMusicInstances.filter(music => music !== musicToRemove);
  },
  SET_CURRENT_SOUND(state, sound) {
    state.currentSound = sound
  },
  SET_CURRENT_MUSIC_INFO(state, info) {
    state.currentMusicInfo = info
  },
  SET_PLAYING_STATE(state, isPlaying) {
    state.isPlaying = isPlaying
  },
  SET_AUTOPLAY_FAILED(state, value) {
    state.autoplayFailed = value
  },
  SET_INITIALIZED(state, value) {
    state.isInitialized = value
  },
  SET_AUTO_MUSIC_SWITCH_ATTEMPTS(state, value) {
    state.autoMusicSwitchAttempts = value;
  },
  INCREMENT_AUTO_MUSIC_SWITCH_ATTEMPTS(state) {
    state.autoMusicSwitchAttempts++;
  },
  INCREMENT_GLOBAL_RETRY_ATTEMPTS(state) {
    state.globalRetryAttempts++;
  },
  RESET_GLOBAL_RETRY_ATTEMPTS(state) {
    state.globalRetryAttempts = 0;
  },
  SET_WAITING_FOR_INTERACTION(state, value) {
    state.waitingForInteraction = value;
  },
  SET_INTERACTION_OBSERVER_ATTACHED(state, value) {
    state.interactionObserverAttached = value;
  }
}

const actions = {
  async playSound({ state, getters }, { category, type, subtype = null, returnAudio = false }) {
    let soundPath;
    if(subtype) soundPath = state.soundEffects[category]?.[type]?.[subtype];
    else soundPath = state.soundEffects[category]?.[type];
    if (!soundPath) return;

    // Add this check before playing UI click sounds
    if (category === 'ui' && type === 'click' && state.isUiClickMuted) {
      return;
    }

    const audio = new Audio(soundPath);
    
    // Set the appropriate volume based on sound type
    if (type === 'ambient') {
      // Esta é a parte crucial - garantir que o tipo seja consistente
      audio.dataset.soundType = `ambient-${category}`;
      audio.volume = getters.effectiveAmbient;
      
      // Adicionar evento para garantir que o volume seja mantido após cada loop
      audio.addEventListener('loop', () => {
        audio.volume = getters.effectiveAmbient;
        console.log(`Loop restart - enforcing ambient volume: ${audio.volume}`);
      });
      
      console.log(`Created ambient sound with volume ${audio.volume}`, audio);
    } else {
      // Regular sound effect
      audio.volume = getters.effectiveSound;
    }
    
    // Only auto-play if returnAudio is false
    if (!returnAudio) {
      try {
        await audio.play();
      } catch (error) {
        console.warn('Auto-play prevented, requires user interaction:', error);
      }
    }

    return returnAudio ? audio : null;
  },

  async playMusic({ state, getters, commit, dispatch }, { category, index = null, startPaused = false }) {
    // If we're already waiting for interaction, don't make additional attempts
    if (state.waitingForInteraction) {
      console.log('Already waiting for user interaction to play music, skipping attempt');
      return;
    }

    try {
      // Stop all currently playing music instances to prevent overlap
      dispatch('stopAllMusicInstances');

      const playlist = state.musicPlaylists[category];
      if (!playlist?.length) return;

      let musicIndex = index !== null ? index : Math.floor(Math.random() * playlist.length);
      
      try {
        const musicTrack = playlist[musicIndex];
        const audio = new Audio(musicTrack.path);
        audio.volume = getters.effectiveMusic;
        audio.loop = false;
        audio.className = 'music-player-audio'; // Add a class for easy identification

        audio.addEventListener('ended', () => {
          commit('REMOVE_MUSIC_INSTANCE', audio);
          dispatch('switchMusic', 'next');
        });

        if (!startPaused && state.isInitialized) {
          // Try to play the music
          await audio.play();
          
          // If we get here, playback succeeded
          commit('SET_CURRENT_MUSIC', audio);
          commit('SET_CURRENT_MUSIC_INFO', { 
            category, 
            index: musicIndex,
            title: musicTrack.title,
            artist: musicTrack.artist
          });
          commit('SET_PLAYING_STATE', true);
          commit('SET_WAITING_FOR_INTERACTION', false);
          commit('SET_INTERACTION_OBSERVER_ATTACHED', false);
          commit('RESET_GLOBAL_RETRY_ATTEMPTS');
          commit('SET_AUTO_MUSIC_SWITCH_ATTEMPTS', 0);
        } else {
          // If starting paused, still set current music but don't play
          commit('SET_CURRENT_MUSIC', audio);
          commit('SET_CURRENT_MUSIC_INFO', { 
            category, 
            index: musicIndex,
            title: musicTrack.title,
            artist: musicTrack.artist
          });
          commit('SET_PLAYING_STATE', false);
        }
      } catch (error) {
        // If autoplay is prevented, we'll enter waiting mode instead of retrying
        console.warn('Autoplay prevented, waiting for user interaction:', error);
        
        // Set up waiting for interaction state
        commit('SET_WAITING_FOR_INTERACTION', true);
        dispatch('attachInteractionObserver', { category, index, startPaused });
      }
    } catch (error) {
      console.warn('Music playback failed:', error);
      commit('SET_PLAYING_STATE', false);
      
      // Set up waiting for interaction instead of retrying
      commit('SET_WAITING_FOR_INTERACTION', true);
      dispatch('attachInteractionObserver', { category, index, startPaused });
    }
  },

  attachInteractionObserver({ state, commit, dispatch }, { category, index, startPaused }) {
    // Only attach once
    if (state.interactionObserverAttached) return;
    commit('SET_INTERACTION_OBSERVER_ATTACHED', true);
    
    console.log("Waiting for first user interaction to play music");
    
    // Enhanced list of interaction events to better capture user gestures
    const interactionEvents = ['click', 'touchstart', 'keydown', 'mousedown', 'pointerdown', 'touchend'];
    
    const interactionHandler = async () => {
      console.log("User interaction detected - attempting to play music");
      
      // Clean up event listeners first
      interactionEvents.forEach(eventType => {
        document.removeEventListener(eventType, interactionHandler);
      });
      
      // Reset states
      commit('SET_INTERACTION_OBSERVER_ATTACHED', false);
      commit('SET_WAITING_FOR_INTERACTION', false);
      commit('RESET_GLOBAL_RETRY_ATTEMPTS');
      commit('SET_AUTO_MUSIC_SWITCH_ATTEMPTS', 0);
      
      // Try unlocking audio context with a silent context first
      try {
        await unlockAudioContext();
      } catch (err) {
        console.warn('Failed to unlock audio context:', err);
      }
      
      // First check and stop any potentially playing music instances
      dispatch('stopAllMusicInstances');
      
      // Now play the requested music
      dispatch('playMusic', { category, index, startPaused });
    };
    
    // Attach once per event type with capture phase to ensure events are caught early
    interactionEvents.forEach(eventType => {
      document.addEventListener(eventType, interactionHandler, { once: true, capture: true });
    });
    
    // Add a visual indicator that music is waiting for interaction
    console.log('Audio autoplay blocked: Waiting for user interaction to start music playback');
  },

  async switchMusic({ state, dispatch, commit }, direction = 'next') {
    // If we're waiting for interaction, don't try to switch music
    if (state.waitingForInteraction) {
      console.log('Waiting for user interaction, skipping music switch');
      return;
    }
    
    // For user-initiated switches, reset counters
    if (direction === 'user-initiated') {
      commit('SET_AUTO_MUSIC_SWITCH_ATTEMPTS', 0);
      commit('RESET_GLOBAL_RETRY_ATTEMPTS');
      direction = 'next';
    } 
    // For auto-switches, track attempts
    else {
      // Only allow 3 automatic switches
      if (state.autoMusicSwitchAttempts >= state.maxRetryAttempts) {
        console.warn(`Maximum auto music switch attempts (${state.maxRetryAttempts}) reached. Stopping auto-switching.`);
        
        // Stop the music and wait for user interaction instead of retrying
        dispatch('stopMusic');
        commit('SET_WAITING_FOR_INTERACTION', true);
        dispatch('attachInteractionObserver', { 
          category: state.currentMusicInfo?.category || 'ambient',
          index: null
        });
        return;
      }
      
      commit('INCREMENT_AUTO_MUSIC_SWITCH_ATTEMPTS');
    }

    if (!state.currentMusic || !state.currentMusicInfo) return;

    const { category, index } = state.currentMusicInfo;
    const playlist = state.musicPlaylists[category];
    
    let newIndex;
    if (direction === 'next') {
      newIndex = (index + 1) % playlist.length;
    } else {
      newIndex = (index - 1 + playlist.length) % playlist.length;
    }

    // Only try to switch if we're not waiting for interaction
    if (!state.waitingForInteraction) {
      await dispatch('playMusic', { category, index: newIndex });
    }
  },

  resetMusicStates({ commit }) {
    commit('SET_AUTO_MUSIC_SWITCH_ATTEMPTS', 0);
    commit('RESET_GLOBAL_RETRY_ATTEMPTS');
    commit('SET_WAITING_FOR_INTERACTION', false);
    commit('SET_INTERACTION_OBSERVER_ATTACHED', false);
  },

  toggleMusicMute({ commit, state, getters, dispatch }) {
    commit('TOGGLE_MUSIC_MUTE');
    dispatch('resetMusicStates');
    
    // If we were waiting for interaction, try to play music now
    if (state.waitingForInteraction) {
      const category = state.currentMusicInfo?.category || 'ambient';
      const index = state.currentMusicInfo?.index || null;
      dispatch('playMusic', { category, index });
    }
    
    if (state.currentMusic) {
      state.currentMusic.volume = getters.effectiveMusic;
    }
  },

  updateMusicVolume({ commit, state, getters, dispatch }, volume) {
    commit('SET_MUSIC_VOLUME', volume);
    dispatch('resetMusicStates');
    
    // If we were waiting for interaction, try to play music now
    if (state.waitingForInteraction) {
      const category = state.currentMusicInfo?.category || 'ambient';
      const index = state.currentMusicInfo?.index || null;
      dispatch('playMusic', { category, index });
    }
    
    if (state.currentMusic) {
      state.currentMusic.volume = getters.effectiveMusic;
    }
  },

  pauseMusic({ state, commit, dispatch }) {
    // Pause all music instances, not just the current one
    state.allMusicInstances.forEach(audio => {
      if (!audio.paused) {
        audio.pause();
      }
    });
    
    commit('SET_PLAYING_STATE', false);
    dispatch('resetMusicStates');
  },

  async resumeMusic({ state, commit, dispatch }) {
    if (state.currentMusic && state.currentMusic.paused) {
      // Make sure no other music is playing first
      state.allMusicInstances.forEach(audio => {
        if (audio !== state.currentMusic && !audio.paused) {
          audio.pause();
        }
      });
      
      try {
        await state.currentMusic.play();
        commit('SET_PLAYING_STATE', true);
        dispatch('resetMusicStates');
      } catch (error) {
        console.warn("Failed to resume music:", error);
        
        // If resuming fails, wait for interaction
        commit('SET_WAITING_FOR_INTERACTION', true);
        const category = state.currentMusicInfo?.category || 'ambient';
        const index = state.currentMusicInfo?.index || null;
        dispatch('attachInteractionObserver', { category, index });
      }
    }
  },

  updateVolumes({ state, getters }) {
    if (state.currentMusic) {
      state.currentMusic.volume = getters.effectiveMusic
    }
  },

  stopAllMusicInstances({ state, commit }) {
    console.log(`Stopping all ${state.allMusicInstances.length} music instances`);
    
    state.allMusicInstances.forEach(audio => {
      if (audio) {
        audio.pause();
        audio.currentTime = 0;
        
        // Remove ended event listeners to prevent memory leaks
        audio.onended = null;
      }
    });
    
    // Clear our tracking array
    commit('CLEAR_ALL_MUSIC_INSTANCES');
  },

  stopMusic({ state, commit }) {
    // Stop and clear all music instances
    if (state.currentMusic) {
      state.currentMusic.pause();
      state.currentMusic.currentTime = 0;
    }
    
    // Also stop any other music instances that might be playing
    state.allMusicInstances.forEach(audio => {
      if (audio && audio !== state.currentMusic) {
        audio.pause();
        audio.currentTime = 0;
      }
    });
    
    commit('CLEAR_ALL_MUSIC_INSTANCES');
    commit('SET_CURRENT_MUSIC', null);
    commit('SET_PLAYING_STATE', false);
  },

  initializeAudio({ commit, dispatch }) {
    commit('SET_INITIALIZED', true);
    
    // Create and test a silent audio context to check autoplay policy
    testAudioAutoplayCapability().then(canAutoplay => {
      if (!canAutoplay) {
        console.warn('Browser autoplay policy detected - waiting for user interaction');
        dispatch('setupSilentAudioContext');
      } else {
        console.log('Browser supports autoplay without user interaction');
      }
    });
  },

  updateAmbientVolume({ commit, dispatch }, volume) {
    commit('SET_AMBIENT_VOLUME', volume);
    dispatch('forceUpdateAmbientSounds');
  },
  
  toggleAmbientMute({ commit, dispatch }) {
    commit('TOGGLE_AMBIENT_MUTE');
    dispatch('forceUpdateAmbientSounds');
  },
  
  forceUpdateAmbientSounds({ getters }) {
    const volume = getters.effectiveAmbient;
    console.log('Forçando atualização de todos os sons ambiente para volume:', volume);
    
    document.querySelectorAll('audio[data-sound-type^="ambient"]').forEach(audio => {
      audio.volume = volume;
      console.log(`Atualizando som ambiente: ${audio.dataset.soundType} para volume ${volume}`);
      
      if (audio.loop) {
        audio.removeEventListener('loop', handleAmbientLoop);
        audio.addEventListener('loop', handleAmbientLoop);
      }
    });
    
    function handleAmbientLoop() {
      this.volume = volume;
      console.log(`Loop trigger - enforcing ambient volume: ${this.volume}`);
    }
  },

  updateAllSoundVolumes({ state, getters }) {
    const soundVolume = getters.effectiveSound;
    document.querySelectorAll('audio:not([data-sound-type^="ambient"]):not(.music-player-audio)').forEach(audio => {
      if (audio !== state.currentMusic) {
        audio.volume = soundVolume;
        console.log(`Regular sound effect volume updated to ${soundVolume}`);
      }
    });
  },

  resetAutoMusicSwitchAttempts({ commit }) {
    commit('SET_AUTO_MUSIC_SWITCH_ATTEMPTS', 0);
  },

  resetAllMusicAttempts({ commit }) {
    commit('SET_AUTO_MUSIC_SWITCH_ATTEMPTS', 0);
    commit('RESET_GLOBAL_RETRY_ATTEMPTS');
    commit('SET_WAITING_FOR_INTERACTION', false);
    commit('SET_INTERACTION_OBSERVER_ATTACHED', false);
  },

  // Add this new action to setup a silent audio context
  setupSilentAudioContext() {
    try {
      // Create a silent audio context to unlock audio on iOS and some browsers
      const AudioContext = window.AudioContext || window.webkitAudioContext;
      if (!AudioContext) return;
      
      const audioCtx = new AudioContext();
      const silentBuffer = audioCtx.createBuffer(1, 1, 22050);
      const source = audioCtx.createBufferSource();
      source.buffer = silentBuffer;
      source.connect(audioCtx.destination);
      source.start();
      
      console.log('Silent audio context created to help unlock audio');
    } catch (err) {
      console.warn('Failed to create silent audio context:', err);
    }
  },
  
  // Add action for testing autoplay capability
  async testAutoplayCapability({ commit }) {
    const canAutoplay = await testAudioAutoplayCapability();
    if (!canAutoplay) {
      commit('SET_AUTOPLAY_FAILED', true);
      commit('SET_WAITING_FOR_INTERACTION', true);
    }
    return canAutoplay;
  }
}

// Helper functions outside the actions object

// Test if autoplay is possible
async function testAudioAutoplayCapability() {
  const audio = new Audio();
  audio.src = 'data:audio/mpeg;base64,/+MYxAAAAANIAUAAAASEEB/jwOFM/0MM/90b/+RhST//w4NFwOjf///PZu////9lns5GFDv//l9GlUIEEIAAAgIg8Ir/JGq3/+MYxDsLIj5QMYcoAP0dv9HIjUcH//yYSg+CIbkGP//8w0bLVjUP///3Z0x5QCAv/yLjwtGKTEFNRTMuOTeqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq';
  audio.volume = 0;
  
  try {
    await audio.play();
    audio.pause();
    return true;
  } catch (err) {
    return false;
  }
}

// Attempt to unlock audio context
async function unlockAudioContext() {
  // For iOS and some browsers, create a short silent sound
  // to unlock the audio context
  const AudioContext = window.AudioContext || window.webkitAudioContext;
  if (!AudioContext) return;
  
  const audioCtx = new AudioContext();
  const buffer = audioCtx.createBuffer(1, 1, 22050);
  const source = audioCtx.createBufferSource();
  source.buffer = buffer;
  source.connect(audioCtx.destination);
  
  // Play the source for a short time
  source.start(0);
  if (audioCtx.state === 'suspended') {
    await audioCtx.resume();
  }
  
  return audioCtx;
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
